import React from 'react';
import "./index.scss";
export const RequiredFieldLabel = () =>{
    return <span className="required-field-label">*</span>
}